import React, { forwardRef } from 'react';

import * as Styled from './popup-menu.style';

export type PopupMenuListProps = {
  hasBottomBorder?: boolean;
  isScrollable?: boolean;
  children: React.ReactNode;
};

export const PopupMenuList = forwardRef<HTMLUListElement, PopupMenuListProps>(
  ({ hasBottomBorder, isScrollable, children }, ref) => (
    <Styled.List
      ref={ref}
      $hasBottomBorder={!!hasBottomBorder}
      $isScrollable={!!isScrollable}
    >
      {children}
    </Styled.List>
  ),
);
